
import { defineComponent, PropType } from 'vue';
import type { ExpansionPanelItem } from '@/types/ExpansionPanels';

export default defineComponent({
  name: 'ExpansionPanels',

  props: {
    eager: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Array as PropType<ExpansionPanelItem[]>,
      default: () => [],
    },
    openPanel: {
      type: Number,
      default: -1,
    },
    mustardBackgroundColor: {
      type: Boolean,
      default: false,
    },
    hasCaretIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    contentLength() {
      return this.content.length;
    },
  },
  methods: {
    resetHash() {
      if (!window.location.hash) return;
      // Safari scrolls to top when assigning to window.location.hash, even with ''.
      // Use replaceState to clear the fragment without triggering navigation.
      // Preserve the existing history state so vue-router scroll/key data survives.
      window.history.replaceState(
        window.history.state,
        '',
        window.location.pathname + window.location.search,
      );
    },
  },
});
